import { expensesTypes } from './actions';

const initialState = {
  expensesByMonth: {},
  activeMonth: null,
  trend: [],
  loadingExpenses: false,
  loadingTrend: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case expensesTypes.GET_EXPENSES.REQUEST: {
      const month = action.payload?.month;
      const force = Boolean(action.payload?.force);
      const cached = month ? state.expensesByMonth[month] : null;

      if (cached && !force) {
        return {
          ...state,
          activeMonth: month,
          loadingExpenses: false,
        };
      }

      return {
        ...state,
        activeMonth: month || state.activeMonth,
        loadingExpenses: true,
      };
    }
    case expensesTypes.GET_EXPENSES.SUCCESS: {
      const month = action.payload.month || state.activeMonth;
      return {
        ...state,
        expensesByMonth: {
          ...state.expensesByMonth,
          [month]: action.payload.expenses || [],
        },
        activeMonth: month,
        loadingExpenses: false,
      };
    }
    case expensesTypes.GET_EXPENSES.FAILED:
      return {
        ...state,
        loadingExpenses: false,
      };
    case expensesTypes.GET_TREND.REQUEST:
      return {
        ...state,
        loadingTrend: true,
      };
    case expensesTypes.GET_TREND.SUCCESS:
      return {
        ...state,
        trend: action.payload.trend || [],
        loadingTrend: false,
      };
    case expensesTypes.GET_TREND.FAILED:
      return {
        ...state,
        loadingTrend: false,
      };
    case expensesTypes.CREATE_EXPENSE.SUCCESS:
      return {
        ...state,
        expensesByMonth: {},
      };
    case expensesTypes.UPDATE_EXPENSE.SUCCESS: {
      const month = state.activeMonth;
      const list = state.expensesByMonth[month] || [];
      return {
        ...state,
        expensesByMonth: {
          ...state.expensesByMonth,
          [month]: list.map((expense) =>
            expense.id === action.payload.expense.id
              ? { ...expense, ...action.payload.expense }
              : expense,
          ),
        },
      };
    }
    case expensesTypes.DELETE_EXPENSE.SUCCESS: {
      const month = state.activeMonth;
      const list = state.expensesByMonth[month] || [];
      return {
        ...state,
        expensesByMonth: {
          ...state.expensesByMonth,
          [month]: list.filter((expense) => expense.id !== action.payload.id),
        },
      };
    }
    case expensesTypes.DELETE_RECURRING_EXPENSE.SUCCESS:
      return {
        ...state,
        expensesByMonth: {},
      };
    default:
      return { ...state };
  }
};
